/* eslint-disable no-undef */

let slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

/* SLIDE DOWN */
let slideDown = (target, duration = 500) => {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

/* TOOGLE */
let slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}
//import {slideUp, slideDown, slideToggle} from './_slideElement.js';

document.addEventListener('DOMContentLoaded', function() {

  all_emails = []
  /* */
  /* Add/Remove invite emails START */
  const addEmailBtnWrap = document.querySelector('.js-gr-invite-form__add-email-btn-wrap');
  if (addEmailBtnWrap) {
    const addEmailBtn = addEmailBtnWrap.querySelector('.js-gr-invite-form__add-email-btn');
    const addEmailForm = document.querySelector('.js-gr-invite-form__add-form');
    addEmailBtn.addEventListener('click', () => {
      slideDown(addEmailForm);
      slideUp(addEmailBtnWrap);
    });
    const addEmailInviteBtn = document.querySelector('.js-gr-add-email-invite__button');
    const addedEmailsSet = document.querySelector('.js-gr-added-emails-set');
    addEmailInviteBtn.addEventListener('click', () => {
      const form = addEmailInviteBtn.closest('.js-gr-invite-form__add-form');
      const input = form.querySelector('input[name="email"]');
      const inputError = form.querySelector('.js-gr-add-email-invite__error');
      const inputVal = input.value;
      if (validateEmail(inputVal)) {
        all_emails.push(inputVal)
        // parent.appendChild(el)
        addedEmailsSet.innerHTML = addedEmailsSet.innerHTML + `
        <!-- Added Email -->
        <div class="gr-added-emails-set__item gr-added-email js-gr-added-email">
          <input type="hidden" name="added email" value="${inputVal}" class="gr-added-email__email-input">
          <div class="gr-added-email__email">
            ${inputVal}
          </div>
          <button class="gr-added-email__del js-gr-added-email__del" type="button" arial-label="delete this item">
            <svg class="gr-added-email__del-icon sprite-icon">
              <use xlink:href="/static/gr_img/svg/sprite.svg#close-circle-fill"></use>
            </svg>
          </button>
        </div>
        <!-- /Added Email -->
        `;
        input.value = '';
        slideUp(addEmailForm);
        slideDown(addEmailBtnWrap);
      } else {
        input.classList.add('error');
        inputError.textContent = 'Please enter a valid e-mail address';
      }
    });
  }
  var send_button = $("#send_email")
  send_button.click(function( event) {
    var subject = $("#subject").val()
    var email_message = $("#email_message").val()
      
      $.post("/api/v2/registry_contribute_email/", {email:all_emails,subject:subject,email_message:email_message}, function(){
      // $("#email_success").show()
      })
      event.preventDefault();
  })


  function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const removeEmailsBtnsSelector = '.js-gr-added-email__del';
  document.addEventListener('click', function(e) {
    // loop parent nodes from the target to the delegation node
    for (var target = e.target; target && target != this; target = target.parentNode) {
      // If click was on remove email button
      if (target.matches(removeEmailsBtnsSelector) || target.closest(removeEmailsBtnsSelector)) {
        removeAddedEmail(target);
        break;
      }
    }
  }, false);
  const removeAddedEmail = (btn) => {
    const item = btn.closest('.js-gr-added-email');
    const timeout = 300;
    slideUp(item, timeout);
    setTimeout(() => {
      item.parentNode.removeChild(item);
    }, timeout)
  }
  /* Add/Remove invite emails END */
  /* */

  /* */
  /* Show contributors message START */
  const showMessageBtns = document.querySelectorAll('.js-gr-contrib-table__message-btn');
  showMessageBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.gr-contrib-table__message');
      const text = wrapper.querySelector('.gr-contrib-table__message-text');
      text.classList.add('is-full');
      btn.classList.add('hidden')
    });
  });
  /* Show contributors message END */
  /* */

  /* */
  /* Copy Link To The Clipboard START */
  const copyToClipBoard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  const shareLinkCopyBtn = document.querySelector('.js-gr-unique-share__copy-btn');
  if (shareLinkCopyBtn) {
    let copyTimeout;
    let copyCallback = () => {
      clearTimeout(copyTimeout);
      shareLinkCopyBtn.classList.add('show-status');
      copyTimeout = setTimeout(() => {
        shareLinkCopyBtn.classList.remove('show-status');
      }, 2000)
    }
    
    shareLinkCopyBtn.addEventListener("click", function()
    {
      const copyText = shareLinkCopyBtn.dataset.copy;
      copyToClipBoard(copyText);
      copyCallback();
    });
  }
  /* Copy Link To The Clipboard END */
  /* */
});
